import { API } from "../constants/api";
import {
  axiosGetWithToken,
  axiosPostWithToken,
} from "../services/apiServices";
import { ERROR_ALERT } from "./commonAction";
import { getDateFilter } from "@flexibees/core";

export const GET_FINAL = "GET_FINAL";
export const FINAL_LOADING = "FINAL_LOADING";
export const FINAL_LOADING_ZOHO = "FINAL_LOADING_ZOHO";
export const SET_FINAL_ITEMS_PER_PAGE = "SET_FINAL_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_FINAL_PAGE = "CHANGE_CURRENT_FINAL_PAGE";
export const SEARCH_FINAL = "SEARCH_FINAL";
export const FILTER_FINAL_FUNCTIONS = "FILTER_FINAL_FUNCTIONS";
export const FILTER_FINAL_ROLES = "FILTER_FINAL_ROLES";
export const PULL_DATA_GET_FINAL = "PULL_DATA_GET_FINAL";
export const FILTER_FINAL_STATUS = "FILTER_FINAL_STATUS";
export const FILTER_FINAL_RECRUITER = "FILTER_FINAL_RECRUITER";
export const FILTER_FINAL_DATE = "FILTER_FINAL_DATE";
export const SET_FINAL_PRICING_HISTORY = "SET_FINAL_PRICING_HISTORY";
export const FILTER_FINAL_POSITION_FILLED = "FILTER_CLOSED_POSITION_FILLED";
export const FILTER_FINAL_NO_DAYS = "FILTER_FINAL_NO_DAYS";
export const FILTER_FINAL_FLEXIBEES_SELECTED =
  "FILTER_FINAL_FLEXIBEES_SELECTED";
export const FILTER_FINAL_CLIENT_SELECTED = "FILTER_FINAL_CLIENT_SELECTED";
export const SELECTION_CONFIRMATION_DETAILS = "SELECTION_CONFIRMATION_DETAILS";

export const getFinal = () => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize = getstate().final.FinalResultsPerPage;
    const page = getstate().final.FinalCurrentPage;
    const seachText = getstate().final.FinalSearchText;
    const functions = getstate().final.FinalAppliedFunctionFilter;
    const roles = getstate().final.FinalAppliedRolesFilter;
    const recruiters = getstate().final.FinalAppliedRecruiterFilter;
    const date = getDateFilter(getstate().final.FinalAppliedDateFilter[0]);
    const no_of_days = getstate().final.FinalAppliedNumberOfDaysFilter;

    const no_of_positions = getstate().final.FinalAppliedPositionFilledFilter;
    const flexibees_selected = getstate().final
      .finalAppliedFlexibeesSelectedFilter;
    const client_selected = getstate().final.finalAppliedClientSelectedFilter;

    const body = {
      search_term: seachText,
      filter_data: {
        functions: functions,
        roles: roles,
        recruiters: recruiters,
        start_date: date,
        no_of_days: no_of_days,

        no_of_positions: no_of_positions,
        flexibees_selected: flexibees_selected,
        client_selected: client_selected,
      },
    };

    axiosPostWithToken(
      `${API.GET_FINAL}/${pagesize}/${page}/`,
      body,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: GET_FINAL,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Unable to fetch data",
        });
      }
    });
  };
};

export const closeProject = (projectId, body, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPostWithToken(`${API.CLOSE_PROJECT}/${projectId}/`, body, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          refresh();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Unable to process request",
          });
        }
      }
    );
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: SET_FINAL_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: CHANGE_CURRENT_FINAL_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: SEARCH_FINAL,
      payload: value,
    });
  };
};

export const filterFunctions = (functions) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_FUNCTIONS,
      payload: functions,
    });
  };
};

export const filterRoles = (roles) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_ROLES,
      payload: roles,
    });
  };
};

export const filterStatus = (status) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_STATUS,
      payload: status,
    });
  };
};

export const filterRecruiter = (recruiter) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_RECRUITER,
      payload: recruiter,
    });
  };
};

export const filterPositionFilled = (position) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_POSITION_FILLED,
      payload: position,
    });
  };
};

export const filterStartDate = (date) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_DATE,
      payload: date,
    });
  };
};

export const filterNoOfDays = (days) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_NO_DAYS,
      payload: days,
    });
  };
};
export const filterFlexibeesSelected = (selected) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_FLEXIBEES_SELECTED,
      payload: selected,
    });
  };
};

export const filterClientSelected = (selected) => {
  return async (dispatch) => {
    dispatch({
      type: FINAL_LOADING,
    });
    dispatch({
      type: FILTER_FINAL_CLIENT_SELECTED,
      payload: selected,
    });
  };
};

export const selectionConfrimationData = (project_id,) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosGetWithToken(`${API.SELECTION_CONFIRMATION_DETAILS}/${project_id}/`, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: SELECTION_CONFIRMATION_DETAILS,
            payload: res?.data?.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Unable to fetch data.",
          });
        }
      }
    ).catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};